<template>
  <div>
        <div class="update_wrap">
            <span class="text_span">刷新时间: {{lodeTime}}</span>
            <img src="../../assets/img/update_btn.png" @click="refresh" alt="">
        </div>
        <table class="ivu-table table m-t-10" cellspacing="0" cellpadding="0">
            <tr>
                <th v-for="(tab,$index) in list" :key="$index" :class="list.length == 1?'textC':''">
                    <span class="ivu-table-cell">{{tab.pointName}}({{tab.unit}})</span>
                </th>
            </tr>
            <tr>
                <th v-for="(tab,$index) in list" :key="$index" :class="list.length == 1?'textC':''">
                    <span class="ivu-table-cell">{{tab.value}}</span>
                </th>
            </tr>
        </table>
        <div class="textRight m-t-10" style="background:linear-gradient(90deg, rgb(69, 161, 205) 0px, rgb(4 25 54) 30%);">
            <span class="fLeft lh32 text_span">浓度趋势%</span>
        </div>
        <line-chart class="m-t-10" :id="'line-chart-0'" :height="'240px'" :y="lineData.y" :x="lineData.x"></line-chart>
        <div class="m-t-10">
            <span class="text_span">气体浓度统计</span>
        </div>
        <table class="ivu-table table m-t-10" cellspacing="0" cellpadding="0">
            <tr>
                <th>
                    <span class="ivu-table-cell">最大气体浓度</span>
                </th>
                <th>
                    <span class="ivu-table-cell">发生时间</span>
                </th>
                <th>
                    <span class="ivu-table-cell">最小气体浓度</span>
                </th>
                <th>
                    <span class="ivu-table-cell">发生时间</span>
                </th>
            </tr>
            <tr>
                <th>
                    <span class="ivu-table-cell">{{loadValue.maxValue}}</span>
                </th>
                <th>
                    <span class="ivu-table-cell">{{loadValue.maxTime}}</span>
                </th>
                <th>
                    <span class="ivu-table-cell">{{loadValue.minValue}}</span>
                </th>
                <th>
                    <span class="ivu-table-cell">{{loadValue.minTime}}</span>
                </th>
            </tr>
        </table>
    </div>
</template>
<script>
import lineChart from '@/components/line.vue';
import { getDate } from '@/assets/js/index.js';
export default {
  name:"",    
  data: () => ({
    lineData: {
        x: [],
        y: [],
    },
    loadValue: {},
    lodeTime: '',
    list: [],
  }),
  props: ['partId'],
  components: {
    lineChart
  },
  created() {

  },
  mounted() {
    this.getData();
  },
  computed: {

  },
  methods: {
    getData(){
        this.refresh();
        this.getTable();
        this.getChart();
        this.getDetail();
    },
    refresh() {
        this.lodeTime = getDate(new Date().getTime(), 'year');
        this.getTable();
        this.getChart();
        this.getDetail();
    },
    getChart() {
        return new Promise((resolve, reject) => {
            let url = `/mcbw/network_monitor/graph/${this.partId}`;
            let _this = this;
            var data = {
                type: 'get',
                url: url,
                obj: {
                    orgId: this.$store.state.baseInfoLayer.baseInfoId,
                    type: 'nd',
                }
            };
            _this.$Axios(data).then((res) => {
                if (res) {
                    let arrX = [], arrY = {}, index = 0;
                    for (let item in res.data.data) {
                        let obj = res.data.data[item];
                        for (let y = 0; y < obj.length; y++) {
                            if (index === 0) arrX.push(obj[y]['time'].substring(11,19));
                            if (arrY[item] && arrY[item].length) {
                                arrY[item].push(obj[y]['value'])
                            } else {
                                arrY[item] = [obj[y]['value']];
                            }
                        }
                        if (arrX.length) index = 1;
                    }
                    let translate = {
                        '今日': arrY.today,
                        '昨日': arrY.yesterday,
                    }
                    this.lineData['x'] = arrX;
                    this.lineData['y'] = translate;
                }
                resolve()
            }).catch(err => {
                reject(err)
            })
        })
    },
    getTable() {
        this.lineData =  {
            x: [],
            y: [],
        };
        this.loadValue = {};
        this.list = [];

        return new Promise((resolve, reject) => {
            let url = `/mcbw/network_monitor/pointNowValue/${this.partId}`;
            let _this = this;
            var data = {
                type: 'get',
                url: url,
                obj: {
                    orgId: this.$store.state.baseInfoLayer.baseInfoId,
                    type: 'nd',
                }
            };
            _this.$Axios(data).then((res) => {
                if (res) {
                    this.list = res.data.data;
                }
                resolve()
            }).catch(err => {
                reject(err)
            })
        })
    },
    getDetail() {
        return new Promise((resolve, reject) => {
            let url = `/mcbw/network_monitor/loadValue/${this.partId}`;
            let _this = this;
            var data = {
                type: 'get',
                url: url,
                obj: {
                    orgId: this.$store.state.baseInfoLayer.baseInfoId,
                    type: 'nd',
                }
            };
            _this.$Axios(data).then((res) => {
                if (res) {
                    this.loadValue = res.data.data[0];
                    this.loadValue.maxTime = this.loadValue.maxTime !='~' ? getDate(Number(this.loadValue.maxTime),'year') : '~';
                    this.loadValue.minTime = this.loadValue.minTime !='~' ? getDate(Number(this.loadValue.minTime),'year') : '~';
                }
                resolve()
            }).catch(err => {
                reject(err)
            })
        })
    },
  }
}
</script>
<style lang="scss" scoped>
/deep/ .ivu-table th,
/deep/ .ivu-table td{
    text-align: center;
} 
.text_span{
    color: #515a6e;
}
table{
    width: 100%
}
.update_wrap{
    display: flex;
    justify-content: flex-end;
    .update_info{
        display: flex;
        align-items: center;
        justify-content: space-between;
        span{
            margin-right: 10px;
        }
        img{
            width: 16px;
            height: 16px;
            cursor: pointer;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/detector/nd.vue